// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2d5513e5","925":"7f702e32","964":"70fdacd9","977":"fbac60db"}[chunkId] + ".chunk.js";
};